import {
	CUSTOM_ELEMENTS_SCHEMA,
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	ViewChild,
	afterNextRender,
	input,
} from '@angular/core';
import { Product, RecommendedUniversity } from '@uc/web/shared/data-models';
import { RecommendedUniCardComponent } from '../recommended-uni-card/recommended-uni-card.component';

@Component({
	selector: 'uc-recommended-unis-swiper',
	templateUrl: './recommended-unis-swiper.component.html',
	imports: [RecommendedUniCardComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RecommendedUnisSwiperComponent {
	product = input.required<Product>();
	recommendedUnis = input<RecommendedUniversity[]>([]);

	@ViewChild('swiperRef') protected swiperRef: ElementRef | undefined;

	constructor() {
		afterNextRender(() => {
			this._initSwiper();
		});
	}

	private _initSwiper() {
		const config = {
			slidesPerView: 1.1,
			spaceBetween: 24,
			loop: false,
			noSwipingClass: 'swiper-no-swiping',
			navigation: {
				nextEl: '.swiper-button-next-recommended',
				prevEl: '.swiper-button-prev-recommended',
			},
			pagination: {
				type: 'fraction',
				el: '.carousel-index-recommended',
			},
			breakpoints: {
				// when window width is >= 480px
				590: {
					slidesPerView: 2,
					spaceBetween: 32,
					slidesPerGroup: 2,
				},
				// when window width is >= 968px
				879: {
					slidesPerView: 3,
					spaceBetween: 32,
					slidesPerGroup: 3,
				},
				1189: {
					slidesPerView: 4,
					spaceBetween: 32,
					slidesPerGroup: 4,
				},
			},
		};

		const swiperEl = this.swiperRef?.nativeElement;
		Object.assign(swiperEl, config);
		swiperEl.initialize();
	}
}
